<template>
  <div class="about w3-container">
    <!-- <h1>This is an about page</h1> -->
    <h2>number of patients is: {{patientCount}}</h2>
    <h2>you have access to institutions: {{prisonCount}}</h2>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "about",
  computed: {
    ...mapGetters(["patientCount", "prisonCount", ])
  },
  methods: {
    ...mapActions(["FETCH_PATIENT_LIST"])
  }
};
</script>

<style>
</style>

